import Kfit from '../integrations/Kfit';

export default params =>
  Kfit.get(`/v1/e_cards/calculate`, params)
    .then(res => res)
    .catch(error => error);
